//表单格式
const baseFormConfig = {
    labelCol: { lg: { span: 6 }, md: { span: 4 }, sm: { span: 24 } },
    wrapperCol: { lg: { span: 16 }, md: { span: 20 }, sm: { span: 24 } },
};
export {
    baseFormConfig
}